<template>
  <v-container>
    <v-alert
        :value="true"
        type="info"
      >
        There are no assignments available at this time.
    </v-alert>
  </v-container>
</template>

<script>
export default {

}
</script>
